import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HolidayDateModel, HolidayErrorMessage, HolidayModel } from '@core/services/holiday/holiday.model';
import { HolidayService } from '@core/services/holiday/holiday.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'Teranet-HolidayDateAddEdit',
  templateUrl: './holiday-date-add-edit.component.html',
})
export class HolidayDateAddEditComponent implements OnInit {
  holidayDateFormGroup: FormGroup;
  holidayErrorMessage = HolidayErrorMessage;
  holidays: HolidayModel[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private holidayService: HolidayService,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<HolidayDateAddEditComponent>,
  ) {
    this.holidayDateFormGroup = new FormGroup({
      description: new FormControl('', Validators.required),
      date: new FormControl('', Validators.required),
      holidayId: new FormControl('', Validators.required)
    });
  }

  ngOnInit() {
    this.spinner.show();
    if (this.data) {
      this.holidayDateFormGroup.patchValue({ ...this.data });
    };

    this.holidayService.getHolidays().subscribe(result => {
      if (result) {
        this.holidays = result;
      }
      this.spinner.hide();
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.holidayDateFormGroup.valid) {
      this.spinner.show();

      let payload: HolidayDateModel = {
        date: this.holidayDateFormGroup.get('date').value as Date,
        description: this.holidayDateFormGroup.get('description').value,
        holidayId: this.holidayDateFormGroup.get('holidayId').value,
        id: this.data?.id > 0 ? this.data.id : 0,
        year: new Date(this.holidayDateFormGroup.get('date').value).getFullYear(),
      };

      this.holidayService.insertOrUpdateHolidayDate(payload).subscribe(() => {
        this.spinner.hide();
        this.dialogRef.close();
      });
    }
  }
}
